import {createContext,useContext} from 'react'
import {useAuth} from '../../hooks/useAuth'
import useExposureGuidance from '../../hooks/useExposureGuidance.js'
import useBreadthReading from '../../hooks/useBreadthReading.js'
import useFomoReading from '../../hooks/useFomoReading.js'
import {useMarketWidgetLayout} from '../../hooks/useMarketWidgetLayout.js'
import {useIbkrMarketQuoteSnapshot} from '../../hooks/useIbkrQuoteSnapshot.js'

const Context=createContext(null)
export const useMarketWidgetSession=()=>useContext(Context)

function SignedInSession({userId,children}) {
  const layout=useMarketWidgetLayout(userId)
  const guidance=useExposureGuidance({continuous:true})
  const creditQuote=useIbkrMarketQuoteSnapshot(layout.value.some(w=>w.id==='credit')?'JNK':null)
  const breadth=useBreadthReading(userId)
  const fomo=useFomoReading(userId,layout.value.some(w=>w.id==='fomo'))
  return <Context.Provider value={{userId,layout,guidance,creditQuote,fomo,breadth}}>{children}</Context.Provider>
}
// Owned by the authenticated app shell, never a selected asset or header mount.
export default function MarketWidgetSession({children}) {
  const {user,loading,biometricPending}=useAuth()
  return user?.id&&!loading&&!biometricPending
    ? <SignedInSession key={user.id} userId={user.id}>{children}</SignedInSession>
    : children
}
